<template>
    <div>
      <div
        :class="[disabled ? 'add-document disabled' : 'add-document', prevFile ? 'prevFile' : '', { large }]"
      >
        <div class="add-document__add__image" v-if="!fileName">
          <img src="../assets/add-doc.svg" />
        </div>
        <label
          class="add-document__text"
          :for="id"
          v-if="!fileName && !showUploadedDoc"
          >{{ label }}
          <span class="border-0" v-if="showAllowedFormats"
            >( {{ allowedFormats }} )</span
          >
        </label>
  
        <div class="add-document__text" v-else>
          <div>
            <div v-if="prevFile">{{ prevFileType }} ({{ fileName }})</div>
            <div v-else>{{ fileName }}</div>
          </div>
          <label :for="id">Change</label>
        </div>
        <input
          v-if="!disabled"
          type="file"
          :accept="allowedFormats"
          :id="id"
          @change="handleFileUpload($event)"
          :required="required"
        />
      </div>
  
      <span
        class="border-0"
        style="
          display: block;
          margin-top: -39px;
          margin-left: 46px;
          font-size: 13px;
          color: #e00b5b !important;
        "
        v-if="showAllowedFormatsUnder"
        >( {{ allowedFormats }}, file size must be less than 4MB )</span
      >
    </div>
    <!--  some-QA-test-->
  </template>
  <script>
  export default {
    name: "AddDocument",
  
    props: {
      onChange: Function,
      label: String,
      required: {
        type: Boolean,
        defaultValue: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      showAllowedFormats: {
        type: Boolean,
      },
      showAllowedFormatsUnder: {
        type: Boolean,
      },
      allowedFormats: {
        type: String,
        default: ".pdf,.docx, .doc, .pnd, .png, .jpg, .jpeg, .csv, .xls, .xlsx",
      },
      showUploadedDoc: Boolean,
      uploadedFile: String,
      large: Boolean,
      prevFile: Object,
    },
  
    model: {
      event: "change",
    },
    data() {
      return {
        id: Date.now() + "kyc-file" + Math.random(),
        fileName: this.uploadedFile || "",
        file: undefined,
      };
    },
    methods: {
      handleFileUpload($event) {
        const file = $event.target.files[0];
        if (Math.round(file.size / 1024) > 4096) {
          alert("Please upload a file below 4MB");
          return;
        }
        this.file = file;
        this.fileName = this.file.name;
        this.$emit("change", this.file);
        if (this.onChange) this.onChange(this.file);
      },
    },
    created() {
      if (this.prevFile) {
        this.fileName = this.prevFile.name;
      }
    },
    computed: {
      prevFileType() {
      const userDetails = this.$store.getters.getUserDetails;
      const getKycDocumentType = this.$store.getters["onboarding/getKycDocumentType"];
      return getKycDocumentType[userDetails.business_type][this.prevFile.document_type];
    },
  },
  };
  </script>
  <style lang="scss" scoped>
  .add-document {
    display: flex;
    height: 55px;
    border: 0.5px solid rgba(97, 110, 124, 0.25);
    box-sizing: border-box;
    border-radius: 4px;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    padding: 0 20px;
    margin: 20px 0;
    cursor: pointer;
  
    &.large {
      height: 55px;
    }
  
    .border-0 {
      border: none !important;
    }
  
    max-width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.disabled {
      background: rgba(97, 110, 124, 0.1);
      cursor: none !important;
    }
    &:hover {
      border-width: 1px;
    }
    &__add__image {
      margin-right: 10px;
    }
  
    &__text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      /* identical to box height */
      width: 100%;
      color: #616e7c;
      display: flex;
      justify-content: space-between;
  
      span,
      label {
        color: #e00b5b !important;
        float: right;
        display: block;
        &:hover {
          border-bottom: 1px solid;
        }
      }
    }
    label,
    img {
      cursor: pointer;
    }
    input {
      display: none;
    }
  }
  .prevFile{
    border-color:  rgba(0, 128, 0, 0.46) !important;
  }
  </style>
  